import API from '@/api.js'
import {schoolSubject}from '@/js/standard.js'

// 登录接口（直接导出，不用 this）
export async function loginType(api, username, password, userType, isPhoneLogin, tempKey, userId) {
	try {
		const res = await api.post(api.fileurl.postLogin, {
			username: username,
			password: password,
			userType: userType,
			isPhoneLogin: isPhoneLogin,
			tempKey: tempKey,
			userId: userId
		})
		if (res.data.code == 500) {
			return res.data.msg
		} else if (res.data.code == 200) {
			
			if (res.data.data && res.data.data.tempKey) {
				return res.data.data
			} else {
				let ist = logUserText(res)
				if (ist) {
					return 'true'
				}
			}
		}
		return '登录失败'
	} catch (error) {
		console.error(error)
		return '网络异常'
	}
}

export async function userInfo(api) {
	var id = localStorage.getItem('userId')
	try {
		const res = await API.get(API.school.getUserRoleList,{
			userId: id
		})
		if (res.data.code == 500) {
			return res.data.msg
		} else if (res.data.code == 200) {
			
			await getUserMenuTree()
			await schoolSemeter()
			await schoolSubject()
			if (res.data.data.length) {
				let userInfo = JSON.stringify(res.data.data)
				localStorage.setItem('userInfo', userInfo)
				return 'true'
			} else {
				return 'true'
			}
		}
		return '登录失败'
	} catch (error) {
		console.error(error)
		return '网络异常'
	}
}

export async function getUserMenuTree() {
	var id = localStorage.getItem('userId')
	var platform = localStorage.getItem('userType')
	var orgId=localStorage.getItem('orgId')
	
	try {
		const res = await API.get(API.fileurl.getUserMenuTree, {
			platform: platform,
			userId: id,
			orgId: orgId
		})
		console.log('权限菜单',res)
		if (res.data.code === 500) {
			return res.data.msg
		} else if (res.data.code === 200) {
			if (res.data.data.length) {
				let MenuList =await getAllMenuCodeStr(res.data.data)
				localStorage.setItem('MenuList', MenuList)
				return 'true'
			} else {
				localStorage.setItem('MenuList', '')
				return 'true'
			}
		}
		return '登录失败'
	} catch (error) {
		console.error(error)
		return '网络异常'
	}finally{
		
		
	}
}
export async function schoolSemeter(){
	try {
		//默认查询100条  不要修改这里 涉及缓存问题
		var id=localStorage.getItem('orgId')
		let res=await API.get(API.admin.getSchoolSemesterList,{
			schoolId:id
		})
		console.log("学期数据",res.data.data)
		if(res.data?.data?.records){
			let semeter=JSON.stringify(res.data.data.records)
			localStorage.setItem('semester',semeter)
			return res.data.data.records
		}else{
			localStorage.removeItem('semester')
		}
		
	}catch(error){
		localStorage.removeItem('semester')
	}
}
export async function getAllMenuCodeStr(menuList) {
	let codeArr = [];

	// 递归遍历
	function traverse(list) {
		if (!list || !list.length) return;
		list.forEach(item => {
			if (item.menuCode) {
				codeArr.push(item.menuCode);
			}
			// 递归子菜单 children（不管叫children、child、subMenu 都能改）
			if (item.children && item.children.length) {
				traverse(item.children);
			}
		});
	}

	traverse(menuList);
	// 去重 + 拼接成字符串
	return [...new Set(codeArr)].join(',');
}
//双端登陆
export async function loginTeacher(api, token) {
	try {
		const res = await api.get(api.fileurl.getUserInfoLogin, {
			token: token
		})
		if (res.data.code == 200) {
			if (res.data.data && res.data.data.tempKey) {
				return res.data.data
			} else {
				let ist =await logUserText(res)
				if (ist) {
					// ==============================================
					// 🔥 扫码登录成功 → 自动启动（我加的）
					// ==============================================
					// startLanHeartbeat(api);

					return 'true'
				}
			}
		}
		return '登录失败'
	} catch (error) {
		console.error(error)
		return '网络异常'
	}
}
export async function getCampus() {
	let list = []
	try {
		let res = await API.get(API.school.getSchoolAreaList, {
			schoolId: localStorage.getItem('orgId')
		})
		console.log('res',res.data)
		if (res?.data?.data) {
			list = res?.data?.data || []

		}
	} catch (e) {

	} finally {
		localStorage.setItem('areaList', JSON.stringify(list))
	}

}
//统一缓存，涉及免密登陆
export async function logUserText(res) {
	var list = ['', 'AI智能体互动课堂中台', 'AI智能体互动课堂校平台', 'AI智能体互动课堂学生端', 'AI智能体互动课堂家长端', 'AI智能体互动课堂局端平台']
	console.log('rrrr',res)
	let orgLogo = res.data.data.orgLogo ? res.data.data.orgLogo : list[res.data.data.userType]
	localStorage.setItem('nickName', res.data.data.nickName || '')
	localStorage.setItem('roleType', res.data.data.roleType.toString() || '')
	localStorage.setItem('roleName', res.data.data.roleName || '')
	localStorage.setItem('userId', res.data.data.userId)
	localStorage.setItem('userType', res.data.data.userType)
	localStorage.setItem('token', res.data.data.token)
	localStorage.setItem('orgStatus', res.data.data.orgStatus)
	localStorage.setItem('orgName', res.data.data.orgName)
	localStorage.setItem('orgLogo', orgLogo)
	localStorage.setItem('orgId', res.data.data.orgId)
	localStorage.setItem('stages',res.data.data.stages||'')
	if(res.data.data.userType==2){
		await getCampus()
	}
	if(res.data.data.courseId){
		localStorage.setItem('courseId', res.data.data.courseId)
	}
	if (res.data.data.authId) {
		localStorage.setItem('authId', res.data.data.authId)
	}

	return true
}

// 登出接口
export async function logOutType(api) {
	try {
		const token = localStorage.getItem('token');
		if (!token) {
			return 'true';
		}
		const res = await api.post(api.fileurl.postLogout)
		if (res.data.code === 200) {
			// 登停心跳
			stopLanHeartbeat();
			return 'true';
		} else {
			return 'false'
		}
	} catch (err) {
		return 'false';
	}
}
let lanTimer = null;

// 启动心跳
export function startLanHeartbeat() {
	if (lanTimer) clearInterval(lanTimer);

	lanTimer = setInterval(() => {
		const userId = localStorage.getItem('userId');
		const userType = localStorage.getItem('userType');
		const nickName = localStorage.getItem('nickName');
		const token = localStorage.getItem('token');
		const courseClassId = localStorage.getItem('courseClassId');

		if (!userId || !userType || !token || !courseClassId) return;

		// 上报自己 → 自动同局域网分组
		API.post(API.fileurl.postLanPeers + "?userId=" + userId + "&courseClassId=" + courseClassId +
			"&userType=" + userType + "&nickName=" + encodeURIComponent(nickName)).then(res => {
			console.log('rrr', res.data)
			if (res.data.length > 0) {
				// 这里就是【同教室所有在线设备】
				console.log("✅ 同局域网在线设备：", res.data);

				window._lan_peers = res.data;
			}
		}).catch(() => {});
	}, 10000);
}

// 停止心跳
export function stopLanHeartbeat() {
	if (lanTimer) {
		clearInterval(lanTimer);
		lanTimer = null;
	}
}

// 获取当前局域网设备列表（外部随时调用）
export function getLanPeers() {
	return window._lan_peers || [];
}